export default __webpack_public_path__ + "static/media/Goal Exploration worksheet.2838147d.pdf";